import { ChartSetup } from "./enrollment.chart-controller";

var Highcharts = require('highcharts/highcharts');
require('highcharts/highcharts-more')(Highcharts);


export class ChartBar {

    constructor() { }

    UpdateChart(chartSetup: ChartSetup, yAxisTitle: string = "Number of Participants", numberOfDecimalPoints: number = 0, dateFormat: string = '%b %Y'): void {

        Highcharts.chart('enrollment-chart', {
            chart: {
                type: 'column',
                backgroundColor: 'white',
                zoomType: 'x',
                resetZoomButton: {
                    position: {
                        align: 'right', // right by default
                        verticalAlign: 'top',
                        x: -10,
                        y: 0
                    },
                    relativeTo: 'chart'
                }
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                type: 'datetime',
                //max: maxDate,
                showLastLabel: true,
                labels: {
                    formatter: function () {
                        return Highcharts.dateFormat('%b \'%y', this.value);
                    }
                }
            },
            yAxis: {
                //max: maxEnrollment,
                title: {
                    text: yAxisTitle
                },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '', ',');
                    }
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        textOutline: 'none',
                        color: 'black',
                        fontWeight: 'bold'
                    },
                    formatter: function () {
                        return Highcharts.numberFormat(this.total, numberOfDecimalPoints);
                    }
                }
            },
            plotOptions: {
                series: {
                    states: {
                        inactive: {
                            enabled: false,
                        },
                    },
                },
                column: {
                    stacking: 'normal',
                }
            },
            tooltip: {
                xDateFormat: dateFormat,
                shared: false,
                formatter: function () {
                    let value: string = "<span class='font-size10'>" + Highcharts.dateFormat(dateFormat, this.x) + "</span><br>";
                    value += "<span style='color:" + this.color + "'>●</span> " + this.series.name + ": <b>" + Highcharts.numberFormat(this.y, numberOfDecimalPoints) + "</b>";
                    return value;
                }
            },
            legend: {
                enabled: chartSetup.showLegend
            },
            series: chartSetup.series
        });
    }
}